import { Anchor, Breadcrumbs, Card, Grid, Text } from '@mantine/core';
import queryString from 'query-string';
import { useEffect, useState } from 'react';
import { useLocation, useNavigate, useParams } from 'react-router';
import ErrorMessage from '../../components/ErrorMessage';
import Metadata from '../../components/Metadata';
import TextMessageForm from '../../components/TextMessages/TextMessageForm';
import GuidanceModal from '../../components/UserFlows/guidanceModal';
import { Page } from '../../constants/pageTitles';
import useFetch from '../../helpers/useFetch';

const page = `${Page['textMessage']}`;

const TextMessagesNewPage = () => {
  const fetch = useFetch();
  const location = useLocation();
  const navigate = useNavigate();

  const [textMessage, setTextMessage] = useState();
  const [userError, setUserError] = useState();
  const [loadError, setLoadError] = useState();
  const [guidanceShow, setGuidanceShow] = useState(false);

  const { accountId, domainId } = useParams();

  useEffect(() => {
    const from = queryString.parse(location.search).from;
    if (from) {
      fetch(`/api/admin/accounts/${accountId}/domains/${domainId}/textMessages/${from}`)
        .then(({ textMessage }) => {
          textMessage.name = `Copy of ${textMessage.name}`;
          delete textMessage.id;
          setTextMessage(textMessage);
        })
        .catch(setLoadError);
    } else {
      setTextMessage({
        name: 'New text message',
        message: '',
        onDailyLimitReached: 'reschedule',
        maxReschedules: 3,
      });
    }
  }, [accountId, domainId, fetch, location.search]);

  const create = (textMessage) => {
    fetch(`/api/admin/accounts/${accountId}/domains/${domainId}/textMessages`, {
      method: 'POST',
      body: JSON.stringify(textMessage),
    })
      .then((response) => {
        setTextMessage(response.textMessage);
        setGuidanceShow(true);
      })
      .catch(setUserError);
  };

  if (loadError) {
    return <ErrorMessage message={loadError.message} />;
  }

  const breadcrumbItems = [
    { title: 'Home', href: `#/accounts/${accountId}/domains/${domainId}/analytics` },
    { title: page, href: `#/accounts/${accountId}/domains/${domainId}/textMessages` },
    { title: 'New' },
  ].map((item, index) =>
    item.href ? (
      <Anchor href={item.href} key={index}>
        {item.title}
      </Anchor>
    ) : (
      <Text key={index}>{item.title}</Text>
    )
  );

  return (
    <>
      <Metadata title={`${page} | New`} />
      <Breadcrumbs mb="md">{breadcrumbItems}</Breadcrumbs>
      <GuidanceModal
        type="SMS / Text Message"
        redirect={`/accounts/${accountId}/domains/${domainId}/textMessages`}
        show={guidanceShow}
        elementTypes={['workflows']}
        element={textMessage}
        setShow={() => setGuidanceShow(false)}
        newElement={true}
      />
      <Grid>
        <Grid.Col span={12}>
          <Card withBorder>
            <TextMessageForm
              textMessage={textMessage}
              saveTextMessage={(textMessage) => create(textMessage)}
              onBack={() => navigate(-1)}
            />
          </Card>
        </Grid.Col>
      </Grid>
      {userError ? (
        <div style={{ textAlign: 'right' }}>
          <ErrorMessage message={userError.message} />
        </div>
      ) : null}
    </>
  );
};

export default TextMessagesNewPage;
